import React from "react";
import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { formatMoney } from "./orderViewUtils";

export default function CheckoutRecoveryState({ checkout, onRefresh, busy = false }) {
  const reference = checkout.checkoutReference;
  const refunded = checkout.payment?.status === "refunded";
  const paid = Boolean(checkout.payment?.paidAt || ["paid", "refunded", "refund_pending"].includes(checkout.payment?.status));
  const failed = !paid && ["failed", "cancelled", "expired"].includes(checkout.payment?.status);
  return <section className="order-detail__panel" aria-label={`Checkout ${reference}`}>
    <header className="order-detail__panel-header"><h2>{refunded ? "Refund confirmed" : paid ? "Payment received - order under review" : failed ? "Payment not completed" : "Payment awaiting confirmation"}</h2></header>
    <div className="order-detail__panel-body">
      <p>Checkout reference: <strong>{reference}</strong></p>
      <p>{refunded ? `Refunded: ${formatMoney(checkout.payment.amountRefunded, checkout.payment.currency)}` : paid
        ? `Payment received: ${formatMoney(checkout.payment.amountCaptured, checkout.payment.currency)}. We are reviewing your order. Please do not pay again.`
        : failed ? "No successful payment has been verified for this checkout. Contact support if a charge appears."
        : "Your order will appear once payment is verified. Do not repeat payment while confirmation is pending."}</p>
      {checkout.refund?.status === "processing" ? <p role="status">Your approved refund is awaiting provider confirmation.</p> : null}
      <div className="order-detail__inline-actions">
        {onRefresh ? <button type="button" className="order-detail__button" disabled={busy} onClick={onRefresh}><RefreshCw size={16} /> Refresh status</button> : <Link className="order-detail__button" to={`/order/${encodeURIComponent(reference)}/success`}>View payment status</Link>}
        <Link className="order-detail__button" to={`/contact?orderNumber=${encodeURIComponent(reference)}`}>Contact support</Link>
      </div>
    </div>
  </section>;
}
